import React from 'react';
import styled from '@emotion/styled';
import { CellGroup } from '../FlightListRow';
import * as Airline from '../columns/Airline';
import * as Airport from '../columns/Airport';
import * as DetailsLink from '../columns/DetailsLink';
import * as Time from '../columns/Time';
import * as FlightNumber from '../columns/FlightNumber';
import * as Gate from '../columns/Gate';
import * as Status from '../columns/Status';
import { TextPlaceholder } from './TextPlaceholder';
import { Shimmer } from '../../../../../../ui';
import { StyledRow } from '../FlightList';

const StyledShimmerRow = styled(StyledRow)`
	align-items: center;
`;

const StyledCellGroup = styled(CellGroup)`
	align-items: center;
`;

const ShimmerRow = Shimmer.withComponent(StyledShimmerRow);

export function FlightListRowShimmer() {
	return (
		<ShimmerRow>
			<Airline.StyledCell>
				<TextPlaceholder />
			</Airline.StyledCell>
			<Time.StyledCell>
				<TextPlaceholder />
			</Time.StyledCell>
			<StyledCellGroup>
				<Airport.StyledCell>
					<TextPlaceholder />
				</Airport.StyledCell>

				<FlightNumber.StyledCell>
					<TextPlaceholder />
				</FlightNumber.StyledCell>
			</StyledCellGroup>
			<Gate.StyledCell>
				<TextPlaceholder />
			</Gate.StyledCell>
			<Airline.StyledCell>
				<TextPlaceholder />
			</Airline.StyledCell>

			<StyledCellGroup>
				<Status.StyledCell>
					<TextPlaceholder />
				</Status.StyledCell>
				<DetailsLink.StyledCell>
					<TextPlaceholder />
				</DetailsLink.StyledCell>
			</StyledCellGroup>
		</ShimmerRow>
	);
}
